import { render } from "./App.vue?vue&type=template&id=9f4e8bae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9f4e8bae&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__